<app-navigation
  class="pcoded-navbar"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'theme-horizontal': this.config['layout'] === 'horizontal',
    'mob-open': navCollapsedMob
  }"
  (onNavCollapse)="this.navCollapsed = !this.navCollapsed"
  (onNavCollapsedMob)="navMobClick()"
></app-navigation>
<app-nav-bar class="navbar pcoded-header navbar-expand-lg navbar-light" (onNavCollapsedMob)="navMobClick()"></app-nav-bar>
<app-product-specification-filter-sidebar
  *ngIf="specFilterPanelOpen()"
  [displayConfig]="filterDisplayConfig()">
</app-product-specification-filter-sidebar>
<div class="pcoded-main-container">
  <div class="pcoded-wrapper">
    <div class="pcoded-content">
      <div class="pcoded-inner-content">
        <app-breadcrumb></app-breadcrumb>
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-menu-overlay" (click)="closeMenu()"></div>
  <!-- <app-footer></app-footer> -->

</div>
<!-- <app-configuration></app-configuration> -->
